import { _decorator, ParticleSystem2D, CCInteger, CurveRange } from 'cc';
import { DEV } from 'cc/env';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

@ccclass('Particle2DAction')
export default class Particle2DAction extends BaseAction {
    @property({ type: ParticleSystem2D, displayName: DEV && '粒子元件', tooltip: DEV && '粒子對象' })
    public readonly particle: ParticleSystem2D = null;
    @property({
        displayName: DEV && '重置狀態',
        tooltip: DEV && '是否要重置狀態',
        visible(this: Particle2DAction) {
            return !!this.particle;
        },
    })
    public readonly resetSystem: boolean = false;
    @property({
        displayName: DEV && '發射數量漸變',
        tooltip: DEV && '是否要漸變發射數量',
        visible(this: Particle2DAction) {
            return !!this.particle;
        },
    })
    public readonly enableFadeEmissionRate: boolean = false;
    @property({
        displayName: DEV && '漸變時長',
        tooltip: DEV && '漸變發射數量的時長 (單位:毫秒)',
        type: CCInteger,
        visible(this: Particle2DAction) {
            return !!this.enableFadeEmissionRate;
        },
    })
    public readonly fadeEmissionRateDuration: number = 0;
    @property({
        type: CurveRange,
        displayName: DEV && '漸變曲線',
        tooltip: DEV && '漸變發射數量使用的漸變曲線',
        visible(this: Particle2DAction) {
            return !!this.enableFadeEmissionRate;
        },
    })
    public readonly fadeEmissionRateCurve: CurveRange = new CurveRange();
    @property({
        displayName: DEV && '漸變起始數值',
        tooltip: DEV && '漸變發射數量的起始數值, 填-1時代表使用當前發射數量',
        type: CCInteger,
        visible(this: Particle2DAction) {
            return !!this.enableFadeEmissionRate;
        },
    })
    public readonly fadeEmissionRateStartValue: number = -1;
    @property({
        displayName: DEV && '漸變目標數值',
        tooltip: DEV && '漸變發射數量的目標數值',
        type: CCInteger,
        visible(this: Particle2DAction) {
            return !!this.enableFadeEmissionRate;
        },
    })
    public readonly fadeEmissionRateTargetValue: number = 0;
    @property({
        displayName: DEV && '更新UV資訊',
        tooltip: DEV && '是否要更新UV資訊',
        visible(this: Particle2DAction) {
            return !!this.particle && this.resetSystem;
        },
    })
    public readonly updateUVs: boolean = false;
}
